import React from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import * as Yup from "yup";
import {Formik} from "formik";
import {createPost} from '../../actions/updateFirestoreData/userData/createPost';
import {showSnackbar} from "../../actions/snackbar";
import FormCreatePost from "../../components/form/FormCreatePost";


/**
 * This class contain a form to sigIn thanks to a password, pseudo and mail input in TextField
 * the action 'sigIn' is used to add information about user if pseudo or mail isn't in database
 */
class CreatePost extends React.Component {

    state = {
        address_lat: null,
        address_lng: null,
    };

    confirmAddress = (lat, lng) => {
        this.setState({
            address_lat: lat,
            address_lng: lng
        });
    };


    handleSubmit = async (values) => {
        let savePost = false;
        const destockage_post = {informations: values};
        destockage_post['date_start'] = new Date(this.state.dateStart);
        destockage_post['date_end'] = new Date(this.state.dateEnd);
        destockage_post['localization'] = [Number(this.state.address_lat), Number(this.state.address_lng)];
        if (values.localization === [0, 0]) {
            this.props.showSnackbar('Votre post doit être localisé', 'error')
        } else if (this.props.auth.type === "admin" || this.props.auth.type === "company") {
            savePost = true;
            await this.props.createPost(destockage_post, this.props.auth, savePost);
        }

    };

    render() {

        const infoField = [
            {name: "login", label: "Nom unique de votre post", type: "text"},
            {name: "name", label: "Nom du lieu", type: "text"},
            {name: "email", label: "Email", type: "text"},
            {name: "sms", label: "Numero de tel", type: "text"},
            {name: "init_price", label: "Prix de depart", type: "number"},
            {name: "price", label: "Prix", type: "number"},
            {name: "description", label: "Description", type: "text"},
        ];

        const dates = [
            {name: "date_start", label: "Date de début"},
            {name: "date_end", label: "Date de fin"},
        ];

        return (
            <>
                <Formik
                    initialValues={{
                        login: "",
                        name: "",
                        email: "",
                        sms: "",
                        description: "",
                        init_price: "",
                        price: "",
                        date_end:'',
                        date_start: ''
                    }}
                    validationSchema={
                        Yup.object({
                            login: Yup.string().required("Champ requis"),
                            name: Yup.string().required("Champ requis"),
                            email: Yup.string().email("format invalide").required("Champ requis"),
                            sms: Yup.string(),
                            price: Yup.number().required("Champ requis"),
                            description: Yup.string().required("Champ requis"),
                            init_price: Yup.number(),
                            date_start: Yup.date().required("Champ requis"),
                            date_end: Yup.date().required("Champ requis"),
                        })
                    }
                    onSubmit={this.handleSubmit}
                >
                    {props =>
                        <FormCreatePost
                            {...props}
                            open={this.state.open}
                            openDialog={this.openDialog}
                            confirmAddress={this.confirmAddress}
                            onClose={this.onClose} setDateStart={this.setDateStart} setDateEnd={this.setDateEnd}
                            dateField={dates} arrayField={infoField}
                        />}
                </Formik>
            </>
        );
    }
}


const mapStateToProps = ({auth}) => {
    return {auth}
};

export default withRouter(connect(
    mapStateToProps,
    {createPost, showSnackbar}
)(CreatePost))
